import app, { Component } from 'apprun';
import { api } from './api';

import SRegionComponent from './service-regions';
import ddlEditComponent from './ddl-edit';

import { doSSO } from './api';
export default class SettingsComponent extends Component {
  state = { initalized: false };

  view = (state) => {
    return (
      <div style={{ width: '500px' }}>
        {(state.access || {}).addRegions ? (
          <span>
            <button type="button" $onclick="add-region">
              Add New Service Region
            </button>
            <br />
            <br />
          </span>
        ) : (
          ''
        )}
        {(state.access || {}).addDDL ? (
          <span>
            <button type="button" $onclick="add-ddl">
              Add to dropdown list
            </button>
            <br />
            <br />
          </span>
        ) : (
          ''
        )}
      </div>
    );
  };

  update = {
    refresh: async (state) => {
      const access = await api.invoke('GET', 'settings/items', '');
      return { ...state, access };
    },

    'add-region': (state) => {
      app.run('#add-panel', {
        id: 'sregion',
        title: 'Add New Service Region',
        Component: SRegionComponent,
        level: 2,
        state: {},
      });
      return state;
    },

    'add-ddl': (state) => {
      app.run('#add-panel', { id: 'addDDL', title: 'Edit List', Component: ddlEditComponent, level: 2, state: {} });
      return state;
    },

    '#sso': (_, partnerId, lang) => {
      lang = lang ? lang : '0';
      partnerId = partnerId.toUpperCase();

      let partnerUrl = '';
      switch (partnerId) {
      case 'RM':
        partnerUrl = 'https://jwt.deluxemod.com';
        break;
      case 'LA':
        partnerUrl = 'https://leads.royallepage.ca/sso/jwt';
        break;
      case 'LL':
        partnerUrl = 'https://learninglibrary.com/bres/A/connect/login';
        break;
      case 'JLR':
        partnerUrl = 'https://www.jlr.ca/PasserelleJLR.aspx?AspxAutoDetectCookieSupport=1';
        break;
      case 'IRE':
        partnerUrl = 'GetFromWebConfig';
        break;
      }
      doSSO(partnerId, partnerUrl, lang);
    },
  };

  mounted = () => {
    this.run('refresh');
  };
}
